/**
 * HTTP utility — POST for data collection. Throws on non-2xx so callers
 * can route to a "failed" branch (e.g. emit pt-form-failed).
 */
export async function post(url: string, data: unknown): Promise<void> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    keepalive: true,
  });
  if (!res.ok) {
    throw new Error('POST ' + url + ' returned ' + res.status);
  }
}
